import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import { createGtm } from '@gtm-support/vue-gtm'

createApp(App)
.use(store)
.use(createGtm({
    id: 'GTM-WCQ73W2',
    //debug: true
}))
.mount('#app')
